import { LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import React, { useRef } from 'react';
import Link from 'next/link';

interface AuthorProps {
  id: string;
  fields: {
    'Author Image': { value: { src?: string; alt?: string } };
    'Author Name': { value: string };
    Email: { value: string };
    hashvalue: { value: string };
    link: LinkField;
    Phone: { value: string };
    slug: { value: string };
    Summary: { value: string };
    'WordPress Id': { value: string };
  };
}

const AuthorComponent: React.FC<AuthorProps> = (props: AuthorProps) => {
  const { fields } = props;
  const summaryRef = useRef<HTMLDivElement>(null);
  const rawName = fields?.['Author Name']?.value ?? '';
  if (!rawName) return null;

  const name = rawName.trim().replace(/\s+/g, ' ');
  const href = `/blog?author=${encodeURIComponent(name)}`;

  return (
    <div className="author-component" id={`author-component-${props.id}`}>
      <div className="author-container">
        <h4>
          About the author <Link href={href}>{name}</Link>
        </h4>
        <div className="author-info">
          <div ref={summaryRef} className="summary expanded">
            <p
              className="content-paragraph"
              dangerouslySetInnerHTML={{ __html: fields?.Summary?.value || '' }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthorComponent;
